import { combineReducers } from 'redux';

import preparationConfirmReducer from './preparationConfirm';
import unprepareConfirmReducer from './unprepareConfirm';
import verificationConfirmReducer from './verificationConfirm';

export default combineReducers({
  preparationConfirm: preparationConfirmReducer,
  unprepareConfirm: unprepareConfirmReducer,
  verificationConfirm: verificationConfirmReducer,
});
